<a><img class="projectImage" *ngIf="projectImage" [src]="projectImage" ></a>
<a *ngIf="projectData">
  {{projectData[0].description}}
</a>
